import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, onSnapshot, deleteDoc, doc } from 'firebase/firestore';
import '../Admin.css'; 

function Enquiries() {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const q = query(collection(db, "contacts"), orderBy("submittedAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const data = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEnquiries(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this enquiry?")) {
      try {
        await deleteDoc(doc(db, "contacts", id));
      } catch (error) {
        console.error("Error deleting document: ", error);
      }
    }
  };

  const filteredEnquiries = enquiries.filter(item => 
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    item.phone.includes(searchTerm)
  );

  return (
    <div className="enquiries-container">
      {/* Search Bar only - Title is now in Topbar */}
      <div className="enquiry-filter-section">
        <div className="search-box">
          <i className="fas fa-search"></i>
          <input 
            type="text" 
            placeholder="Search by name or phone..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="count-info">
          <span>Total Found: <strong>{filteredEnquiries.length}</strong></span>
        </div>
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
          <p>Fetching messages...</p>
        </div>
      ) : (
        <div className="enquiry-list-wrapper">
          {filteredEnquiries.length > 0 ? (
            <div className="table-responsive">
              <table className="custom-admin-table">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Contact Details</th>
                    <th>Message</th>
                    <th>Received At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEnquiries.map((enquiry) => (
                    <tr key={enquiry.id}>
                      <td className="user-info">
                        <div className="avatar">{enquiry.name.charAt(0).toUpperCase()}</div>
                        <strong>{enquiry.name}</strong>
                      </td>
                      <td>
                        <div className="contact-details">
                          <span><i className="fas fa-envelope"></i> {enquiry.email}</span>
                          <span><i className="fas fa-phone"></i> {enquiry.phone}</span>
                        </div>
                      </td>
                      <td className="message-text-cell">
                        <div className="message-bubble">
                          {enquiry.message}
                        </div>
                      </td>
                      <td className="time-cell">
                        <div className="timestamp">
                          <span className="date">{enquiry.submittedAt?.toDate().toLocaleDateString()}</span>
                          <span className="time">{enquiry.submittedAt?.toDate().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                        </div>
                      </td>
                      <td>
                        <div className="action-group">
                          <a 
                            href={`https://wa.me/${enquiry.phone.replace(/\s/g, '')}`} 
                            target="_blank" 
                            rel="noreferrer" 
                            className="action-btn wa-btn"
                            title="Reply via WhatsApp"
                          >
                            <i className="fab fa-whatsapp"></i>
                          </a>
                          <button 
                            onClick={() => handleDelete(enquiry.id)} 
                            className="action-btn del-btn"
                            title="Delete Enquiry"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-state">
              <i className="fas fa-folder-open"></i>
              <p>No messages found matching your search.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Enquiries;